import classNames from "classnames";

// material icons. yes could be better named
import "src/pods/font";

// NOTE: you can get the codes here: https://material.io/icons
const ICON_CODE_POINTS_MAP = {
  keyboard_arrow_left: "&#xE314;",
  arrow_back: "&#xE5C4;",
  close: "&#xE5CD;",
  skip_previous: "&#xE045;",
  pause: "&#xE034;",
  play_arrow: "&#xE037;",
  skip_next: "&#xE044;",
  replay: "&#xE042;",
  replay_10: "&#xE059;",
  forward_10: "&#xE056;",
  fullscreen: "&#xE5D0;",
  fullscreen_exit: "&#xE5D1;",
  devices: "&#xE1B1;",
};

export type Icon = keyof typeof ICON_CODE_POINTS_MAP;

type MaterialIconProps = {
  icon: Icon;
  className?: string;
  onClick?: VoidFunction;
};

/**
 * NOTE: This component is an abstraction to the way we render the icons with legacy compatibility.
 * For example, IE9 and Android 4.x doesn't have ligatures, hence we need to use its respective code
 * points.
 *
 * Please read: https://github.com/google/material-design-lite/issues/1375#issuecomment-130721748.
 *
 */
export default function MaterialIcon({ icon, ...props }: MaterialIconProps) {
  if (ICON_CODE_POINTS_MAP[icon]) {
    return (
      <i
        {...props}
        className={classNames("material-icons", props.className ?? "")}
        dangerouslySetInnerHTML={{ __html: ICON_CODE_POINTS_MAP[icon] }}
      />
    );
  }

  return (
    <i {...props} className={classNames("material-icons", props.className ?? "")}>
      {icon}
    </i>
  );
}
